import React, { useEffect,useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProgramDetail } from "../../features/admin/common/Slice";
import Explore_Banner from "./explore-banner/Explore_Banner";
import Program_Overview from "./program-overview/Program_Overview";
import Key_Highlights from "./key-highlights/Key_Highlights";
import What_Will_Learn from "./what-will-learn/What_Will_Learn";
import Key_Pillars from "./key-pillars/Key_Pillars";
import Data_Curriculum from "./data-curriculum/Data_Curriculum";
import Industry_Standard from "../home/industry-standard/Industry_Standard";
import Career_Support from "./career-support/Career_Support";
import Fee_Enrollment from "./fee-enrolment/Fee_Enrollment";
import Get_A_Call from "./get-a-call/Get_A_Call";
import FAQ from "./faq/FAQ";

const Explore_Program = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    console.log(loading,"loading");
    

  const program = useSelector((state) => state?.common?.program_detail);

  useEffect(() => {
    setLoading(true); 
    dispatch(ProgramDetail(id)).finally(() => setLoading(false)); 
  }, [id, dispatch]);

  return (
    <>
      <Explore_Banner program={program} loading={loading} />
      <Program_Overview program={program} />
      <What_Will_Learn program={program} />
      <Key_Highlights program={program} />
      <Key_Pillars program={program} />
      <Data_Curriculum program={program} />
      <Industry_Standard />
      <Career_Support />
      <Fee_Enrollment />
      <Get_A_Call />
      <FAQ program={program} />
    </>
  );
};

export default Explore_Program;
